import React from 'react';
import styles from '../../LeadVettingPage/components/LeadVettingFormStyles.module.less';

const TermsOfServiceTrialText = (props) => {
  return (
    <>
      <div className={[styles.subTitle, styles.bold].join(' ')}>{gettext('Notice of Non-Permissible Use')}</div>
      <div>
        <span className={styles.boldParagraph}>
          {gettext('This limited trial of Pipl’s products and services (“Pipl Trial”)')}
        </span>
        <span>
          {gettext(
            ' is exclusively intended to support the needs of professionals in organizations having certified, lawful, and legitimate identity data verification and investigative requirements.',
          )}
        </span>
      </div>
      <div className={styles.boldParagraph}>
        {gettext('Pipl Trials are not intended for personal, non-commercial purposes.\n')}
      </div>

      <div>
        <div className={styles.line}>
          <div className={styles.dot}>•</div>
          <p className={styles.paragraph}>
            <span>{gettext(`Use of `)}</span>
            <span className={styles.boldParagraph}>{gettext('Pipl Trial')}</span>
            <span>
              {gettext(
                ` by you and your designees must be in compliance with all applicable laws and may not be used for, or in connection with, any illegal activity.`,
              )}
            </span>
          </p>
        </div>
        <div className={styles.line}>
          <div className={styles.dot}>•</div>
          <p className={styles.paragraph}>
            <span>{gettext(`You may not use Pipl `)}</span>
            <span className={styles.boldParagraph}>{gettext('Trial')}</span>
            <span>{gettext(` Trial in any way that violates or infringes upon individual rights.`)}</span>
          </p>
        </div>

        <div className={styles.line}>
          <div className={styles.dot}>•</div>
          <p className={styles.paragraph}>
            <span>{gettext(`If you are U.S. entity/person, or that the person searched in `)}</span>
            <span className={styles.boldParagraph}>{gettext('the Pipl Trial')}</span>
            <span>
              {gettext(
                ` is a U.S. person, You will not, and if applicable, instruct Your end-users not to, use the information made available by `,
              )}
            </span>
            <span className={styles.boldParagraph}>{gettext('the Pipl Trial')}</span>
            <span>
              {gettext(
                ` to determine a consumer’s eligibility for (a) credit or insurance for personal, family or household purposes, (b) employment or (c) a government license or benefit or (d) any other purpose governed by the Fair Credit Reporting Act (FCRA).`,
              )}
            </span>
          </p>
        </div>

        <div className={styles.line}>
          <div className={styles.dot}>•</div>
          <p className={styles.paragraph}>
            <span>{gettext(`You may not use Pipl `)}</span>
            <span className={styles.boldParagraph}>{gettext('Trial')}</span>
            <span>
              {gettext(
                ` to obtain contact information that will be used to send unsolicited email (SPAM) or unsolicited phone calls (robocalling).`,
              )}
            </span>
          </p>
        </div>

        <div className={styles.line}>
          <div className={styles.dot}>•</div>
          <p className={styles.paragraph}>
            <span>{gettext(`You will not use the data retrieved from the Pipl `)}</span>
            <span className={styles.boldParagraph}>{gettext('Trial')}</span>
            <span>
              {gettext(
                ` to target and/or offer Your goods/services to data subjects from the European Economic Area or the United Kingdom.`,
              )}
            </span>
          </p>
        </div>

        <div className={styles.line}>
          <div className={styles.dot}>•</div>
          <p className={styles.paragraph}>
            <span>{gettext(`You may not use Pipl `)}</span>
            <span className={styles.boldParagraph}>{gettext('Trial')}</span>
            <span>{gettext(` for any political campaign.`)}</span>
          </p>
        </div>

        <div className={styles.line}>
          <div className={styles.dot}>•</div>
          <p className={styles.paragraph}>
            <span>
              {gettext(
                `During the Pipl Trial, Pipl makes no warranties of any kind and assumes no liability associated with the Pipl Trial.`,
              )}
            </span>
          </p>
        </div>

        <div className={styles.line}>
          <div className={styles.dot}>•</div>
          <p className={styles.paragraph}>
            <span>
              {gettext(
                `Pipl reserves the right to apply reasonable and ongoing measures to assess and assure the proper use of `,
              )}
            </span>
            <span className={styles.boldParagraph}>{gettext('the Pipl Trial')}</span>
            <span>
              {gettext(` and we reserve the right to deny service to any customer who we suspect may be using `)}
            </span>
            <span className={styles.boldParagraph}>{gettext('the Pipl Trial')}</span>
            <span>{gettext(` for non-permissible purposes.`)}</span>
          </p>
        </div>
      </div>
    </>
  );
};
TermsOfServiceTrialText.propTypes = {};

export default TermsOfServiceTrialText;
